<template>
  <b-overlay :show="loading" z-index="1010">
    <b-container fluid>
      <b-row>

        <left-nav v-if="showNav"></left-nav>
        
        <b-col cols="12" :md="showNav ? 9 : 12" :xl="showNav ? 10 : 12">
          <top-nav v-if="showNav" />
          <b-row class="pt-2">
            <router-view />
          </b-row>
        </b-col>

      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import TopNav from '@/components/TopNav.vue';
import LeftNav from '@/components/LeftNav.vue';
import { store } from '@/store';
import Api from '@/lib/Api';
import EventBus from '@/lib/EventBus';


export default {
    name: 'App',
    components: {
        TopNav,
        LeftNav
    },
    data () {
        return {
            loading: false
        };
    },
    computed: {
        showNav () {
            return !['login'].includes(this.$route.name);
        }
    },
    created () {
        EventBus.$on('load-projects', this.loadProjects);
        EventBus.$on('error', this.showError);
        EventBus.$on('set-loading', this.setLoading);
    },
    beforeDestroy () {
        EventBus.$off('load-projects', this.loadProjects);
        EventBus.$off('error', this.showError);
        EventBus.$off('set-loading', this.setLoading);
    },
    methods: {

        async loadProjects () {
            console.log('Loading projects');
            this.loading = true;
            try {
                const projects = await Api.getProjects();
                store.setProjects(projects);
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки проектов', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        },

        showError (error) {
            var msg = 'Произошла ошибка';
            if (error.type === 'api') {
                msg = error.errors[0]['message'];
            } else {
                msg = error.error;
            }
            this.$bvToast.toast(msg, {
                title: 'Ошибка',
                variant: 'danger',
                solid: true,
                noAutoHide: true
            });
        },

        setLoading (value) {
            this.loading = value;
        }

    },
}
</script>

<style lang="scss">
</style>
